import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminInquiries.supplementDetails;
export const adminSupplementDetailsActiveIdSelector = (state: RootState) =>
  getState(state).activeId;
export const adminSupplementDetailsSelector = (state: RootState) => getState(state).data;
export const adminSupplementDetailsIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const adminSupplementDetailsErrorSelector = (state: RootState) => getState(state).error;
export const adminSupplementDetailsIsDeactivatingSelector = (state: RootState) =>
  getState(state).isDeactivating;
export const adminSupplementDetailsStatusSelector = (state: RootState) =>
  adminSupplementDetailsSelector(state)?.adminSupplementInquiryStatusId;
